


















































import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({})
export default class Tail extends Vue {
  @Prop({ default: true }) public ifShowIcon: any;
  private nameEn: string = this.$subName == 'longyixiu' ? 'LongYiXiu' : this.$subName == 'wenjuanjia' ? 'WenJuanJia' : 'LongYiXiu';
  private goArticle() {
    this.$router.push({
      path: '/help.html',
      query: {
        articleId: '13',
      },
    });
  }
  private to(type: any) {
    if (type === 1) {
      if (this.$subName == 'longyixiu') {
        window.open(`${process.env.VUE_APP_PREVIEW_URL}` + '/?questionId=FnMQYjGt8geUkFehIJTl1A%3D%3D', '_blank');
      } else if (this.$subName == 'wenjuanjia') {
        window.open('https://wj.wenjuanjia.com/?questionId=aXEietY1ICqFOZtOjJS1hg%3D%3D', '_blank');
      }
    } else if (type === 2) {
      if (this.$subName == 'longyixiu') {
        window.open(`${process.env.VUE_APP_PREVIEW_URL}` + '/?questionId=%2FnqDJcyEeLLpTW1BYRZAyw%3D%3D', '_blank');
      } else if (this.$subName == 'wenjuanjia') {
        window.open('https://wj.wenjuanjia.com/?questionId=h6PpFJq7njmffO%2FBFhF1yA%3D%3D', '_blank');
      }
    }
  }
}
